import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIALS]: {
		url:'/company/:companyId/done_works/:doneWorkId/manufactured_materials/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/manufactured_materials/:manufacturedMaterialId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/manufactured_materials/:manufacturedMaterialId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/manufactured_materials/:manufacturedMaterialId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].CREATE_DONE_WORKS_MANUFACTURED_MATERIAL]: {
		url:'/company/:companyId/done_works/:doneWorkId/manufactured_materials/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PATCH_DONE_WORKS_MANUFACTURED_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/manufactured_materials/:manufacturedMaterialId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PUT_DONE_WORKS_MANUFACTURED_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/manufactured_materials/:manufacturedMaterialId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].DELETE_DONE_WORKS_MANUFACTURED_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/manufactured_materials/:manufacturedMaterialId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}